import { RouteConstants } from "../constants";
import IRoute from "../models/route.interface";
import { ViewEcgPage } from "../pages/ViewEcgPage/ViewEcgPage";
import { ViewPrescriptionPage } from "../pages/ViewPrescriptionPage/ViewPrescriptionPage";

export const publicRoutes: IRoute[] = [
  {
    id: RouteConstants.VIEW_ECG,
    path: RouteConstants.VIEW_ECG_PATH,
    component: <ViewEcgPage />,
  },
  {
    id: RouteConstants.VIEW_PRESCRIPTION,
    path: RouteConstants.VIEW_PRESCRIPTION_PATH,
    component: <ViewPrescriptionPage />,
  },
];
